import { render, staticRenderFns } from "./DiscordIcon.vue?vue&type=template&id=73f4cb00&scoped=true&"
import script from "./DiscordIcon.vue?vue&type=script&lang=ts&"
export * from "./DiscordIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f4cb00",
  null
  
)

export default component.exports